import Contato from "../components/Contato";

export default function ContatoPage() {
  return (
    <div data-testid="page-contato" className="pt-24 sm:pt-32">
      <Contato />
    </div>
  );
}
